import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { addToast, removeToast, removeToastAfterDelay } from './loyaltyToastActions';
import type { Toast } from './loyaltyToastTypes';

export function useLoyaltyToast() {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((s) => s.loyaltyToast.toasts);

  const addToastFn = useCallback(
    (
      message: string,
      variant: Toast['variant'] = 'success',
      position: Toast['position'] = 'bottom-right',
    ) => {
      const id = crypto.randomUUID();
      dispatch(addToast({ id, message, variant, position }));
      dispatch(removeToastAfterDelay(id));
    },
    [dispatch],
  );

  const removeToastFn = useCallback((id: string) => dispatch(removeToast(id)), [dispatch]);

  return { toasts, addToast: addToastFn, removeToast: removeToastFn };
}
